import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_CHAUFFEUR, UPDATE_CHAUFFEUR_SUCCESS, UPDATE_CHAUFFEUR_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* updateChauffeur({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/chauffeur/status`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_CHAUFFEUR_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_CHAUFFEUR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_CHAUFFEUR_ERROR, payload: error });
  }
}

export function* watchupdateChauffeur() {
  yield takeEvery(UPDATE_CHAUFFEUR, updateChauffeur);
}

function* updateChauffeurSaga() {
  yield all([fork(watchupdateChauffeur)]);
}

export default updateChauffeurSaga;
